import { render, staticRenderFns } from "./discardedElectronics.vue?vue&type=template&id=91a69902&scoped=true"
import script from "./discardedElectronics.vue?vue&type=script&lang=js"
export * from "./discardedElectronics.vue?vue&type=script&lang=js"
import style0 from "./discardedElectronics.vue?vue&type=style&index=0&id=91a69902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a69902",
  null
  
)

export default component.exports